import localForage from 'localforage';
import { persistReducer } from 'redux-persist';
import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'app/store';
import { type DirectPrintAgentsState, type DirectPrintAgentsActionTypes } from 'app/store/types';

const initialState: DirectPrintAgentsState = {};

const directPrintAgentsReducer = (state = initialState, action: DirectPrintAgentsActionTypes) => {
	switch (action.type) {
		case 'GET_LICENSE_GROUP_DATA_SUCCESS': {
			const {
				licenseGroupId,
				data: { directPrintAgents },
			} = action.payload;

			return {
				...state,
				[licenseGroupId]: {
					...state[licenseGroupId],
					...(directPrintAgents && { byId: directPrintAgents }),
				},
			};
		}
		case 'LOGGED_OUT_USER':
		case 'PURGE_STATE':
			return initialState;
		default: {
			return state;
		}
	}
};

export default persistReducer(
	{
		key: 'directPrintAgents',
		storage: localForage,
		whitelist: localStorage.getItem('persist') ? undefined : [],
	},
	directPrintAgentsReducer,
);

// Selectors
export const getDirectPrintAgentsById = ({ app: { selectedLicenseGroupId }, directPrintAgents }: RootState) =>
	directPrintAgents[selectedLicenseGroupId].byId;

export const getDirectPrintAgents = createSelector([getDirectPrintAgentsById], (directPrintAgentsById) =>
	Object.values(directPrintAgentsById),
);
